import React from 'react';

import { HiOutlineOfficeBuilding } from 'react-icons/hi';

import { useRolesStyles } from '../styles';

interface Props {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
}

/**
 * The empty state for anything inside the roles/staff panels — a card with an
 * icon, a title and a line of guidance. Deliberately not a small caption: an
 * empty panel with one grey line reads as a loading glitch.
 */
export const RolesEmptyState: React.FC<Props> = ({
  title = 'No companies assigned yet',
  subtitle = 'Roles and permissions will appear here once this user joins a company.',
  icon = <HiOutlineOfficeBuilding size={28} />,
}) => {
  const classes = useRolesStyles();
  return (
    <div className={classes.emptyRoot}>
      <div className={classes.emptyIconWrap}>{icon}</div>
      <div className={classes.emptyTitle}>{title}</div>
      <div className={classes.emptySubtitle}>{subtitle}</div>
    </div>
  );
};
